var $b63be9b0371e788c$exports = {};
const $b63be9b0371e788c$var$input = document.getElementById("input");
const $b63be9b0371e788c$var$analyzeButton = document.getElementById("analyzeButton");
const $b63be9b0371e788c$var$output = document.getElementById("output");
const $b63be9b0371e788c$var$languageSelect = document.getElementById("languageSelect");
const $b63be9b0371e788c$var$API_URL = "https://openrouter.ai/api/v1/chat/completions";
function $b63be9b0371e788c$var$escapeHtml(value) {
    return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}
function $b63be9b0371e788c$var$renderMarkdown(text) {
    const codeBlocks = [];
    const withPlaceholders = text.replace(/```(\w+)?\n([\s\S]*?)```/g, (_match, lang, code)=>{
        const trimmed = code.replace(/\n$/, "");
        const escaped = $b63be9b0371e788c$var$escapeHtml(trimmed);
        const className = lang ? ` class="language-${lang}"` : "";
        const html = `<pre><code${className}>${escaped}</code></pre>`;
        codeBlocks.push(html);
        return `@@CODEBLOCK_${codeBlocks.length - 1}@@`;
    });
    let html = $b63be9b0371e788c$var$escapeHtml(withPlaceholders);
    html = html.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
    html = html.replace(/`([^`]+?)`/g, "<code>$1</code>");
    html = html.replace(/@@CODEBLOCK_(\d+)@@/g, (_match, index)=>{
        return codeBlocks[Number(index)] || "";
    });
    return html;
}
$b63be9b0371e788c$var$analyzeButton.addEventListener("click", async ()=>{
    const errorMessage = $b63be9b0371e788c$var$input.value;
    const language = $b63be9b0371e788c$var$languageSelect.value;
    $b63be9b0371e788c$var$output.textContent = "Analyzing...";
    const options = {
        method: "POST",
        headers: {
            Authorization: `Bearer ${"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"}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            model: "z-ai/glm-4.5-air:free",
            messages: [
                {
                    role: "user",
                    content: `Explain this error in ${language}: ${errorMessage}`
                },
                {
                    role: "system",
                    content: "You are an expert software developer who explains error messages clearly and concisely."
                }
            ]
        })
    };
    try {
        const response = await fetch($b63be9b0371e788c$var$API_URL, options);
        const data = await response.json();
        const content = data?.choices?.[0]?.message?.content || "";
        $b63be9b0371e788c$var$output.innerHTML = $b63be9b0371e788c$var$renderMarkdown(content);
    } catch (error) {
        $b63be9b0371e788c$var$output.textContent = `Error: ${error.message}`;
    }
});


//# sourceMappingURL=path0.143bb4e6.js.map
